import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { alpha, useTheme, Chip } from '@emburse/embark-core';
import { InterchangeTableContext } from './InterchangeTableProvider';
function DayChip({ label, field }) {
    const theme = useTheme();
    const { selectedRow, setSelectedRow } = useContext(InterchangeTableContext);
    return (_jsx(Chip, { label: label, color: "primary", variant: "outlined", style: {
            backgroundColor: selectedRow[field]
                ? alpha(theme.palette.primary.main, 0.0784)
                : 'initial'
        }, onClick: () => setSelectedRow({ ...selectedRow, [field]: !selectedRow[field] }) }));
}
export default DayChip;
